export const IMPERSONATE_TEXTS = {
  MENU_ITEM_LABEL: 'Logar como usuário',
  BUTTON_LABEL: 'Logar como usuário',
  REDIRECTING: 'Aguarde! Você está sendo redirecionado.',
  DEFAULT_ERROR: 'Ocorreu um erro ao tentar logar como o usuário.',
};

export const IMPERSONATE_ERROR_MESSAGES = new Map([
  ['UNVERIFIED', 'O cliente ainda não verificou o e-mail.'],
]);
